import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Agenda from "./pages/Agenda";
import Geschiedenis from "./pages/Geschiedenis";
import News from "./pages/News";
import Layout from "./pages/Layout";
import "./assets/scss/harpe-davids-brunssum.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
      </Route>
      <Route path="/artikel" element={<Layout />}>
        <Route index element={<News />} />
      </Route>
      <Route path="/geschiedenis" element={<Layout />}>
        <Route index element={<Geschiedenis />} />
      </Route>
      <Route path="/agenda" element={<Layout />}>
        <Route index element={<Agenda />} />
      </Route>
      <Route path="*" element={<p>There's nothing here: 404!</p>} />
    </Routes>
  </BrowserRouter>
);
